import { Component, OnInit, inject } from "@angular/core";
import { Order } from "../../../../Models/order";
import { OrderService } from "../../../../Services/order.service";
import { ActivatedRoute, Router } from "@angular/router";
import { WiSnackBarService } from "../../../../Services/wi-snackBar.service";
import { Client } from "../../../../Models/client";
import { AccountService } from "../../../../Services/account.service";
import { OrderProduct } from "../../../../Models/order-product";
import { LicenceKey } from "../../../../Models/licenceKey";
import { Transaction } from "../../../../Models/transaction";
import { DatePipe } from "@angular/common";
import { ProjectTheme } from "src/app/Models/ProjectTheme";
import { translateOrderState } from "../../../../Models/order";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "src/app/Services/language.service";
//import * as html2pdf from "html2pdf.js";

export interface DialogData {
  product_name: string;
  image: any;
  productId: number;
  orderProductId: number;
  refConstructor: string;
  codFAB: string;
  codEAN: string;
  order: Order;
  orderProduct: OrderProduct;
  installLink: string;
  licenseKeySet: LicenceKey[];
}

@Component({
    selector: "app-order-details",
    templateUrl: "./order-details.component.html",
    styleUrls: ["./order-details.component.scss"],
    standalone: false
})
export class OrderDetailsComponent implements OnInit {
  readonly DEFAULT_PRODUCT_IMAGE = "assets/images/logo_placeholder.png";
  steps:
    | "NoStep"
    | "step1"
    | "step2"
    | "step2-canceld"
    | "step3"
    | "step3-canceld"
    | "step4"
    | "step4-canceld"
    | "end" = "NoStep";
  orderRef!: string;
  bank: ProjectTheme = "WUnivers";
  orderDate!: Date;
  orderStatus!: string;
  itemsNbr!: number;
  isLoading: boolean = true;
  orderInfo: {
    id: number;
    productName: string;
    Quantity: number;
    unitPrice: number;
    imagePath: string;
  }[] = [];

  simulationInfo: {
    periodicity: string;
    dateOfBirth: Date;
    salary: number;
    phoneNumber: string;
    storeAddress: string;
  } = {
    periodicity: "",
    dateOfBirth: new Date(),
    salary: 0,
    phoneNumber: "",
    storeAddress: "",
  };
  totalOrder: {
    deliveryCost: number | string;
    tva: string;
    totalAmountHT: number;
    amountToFinance: number;
    monthlyPayment: number;
    months: number;
  } = {
    deliveryCost: 0,
    tva: "",
    totalAmountHT: 0,
    amountToFinance: 0,
    monthlyPayment: 0,
    months: 0,
  };
  deliveryAddress: {
    address: string;
    commune?: string;
    wilaya: string;
  } | null = null;
  deliveryOption = "";
  paymentOption = "";
  /** Payment method code (VIREMENT…): lib-order-details shows the virement receipt step from it, in any language */
  paymentMethod = "";
  transferReceipt: { fileName: string; url?: string; comment?: string } | null =
    null;
  transferReceiptLoading = false;
  /** Delivery types with a label under `account.orderDetails.deliveryTypes` */
  readonly DELIVERY_TYPES = [
    "POINT_DE_RELAIT",
    "DOMICILE",
    "RECUPERATION_AU_NIVEAU_DU_MAGASIN",
    "DELIVERY_BY_TAXI",
  ];
  /** Payment methods with a label under `account.orderDetails.paymentMethods` */
  readonly PAYMENT_METHODS = ["CASH_EN_DELIVERY", "CIB_ELDAHABIA", "VIREMENT"];
  customer?: Client;
  order: Order | null = null;
  showLoader = false;
  client: Client | null = null;
  lastOrder: Order | null = null;
  Order?: Order;
  TotalHT = 0;
  show = false;
  idOrder?: number;
  succeededTransaction: Transaction | null = null;
  isExporting = false;
  emailIsSending = false;
  baseUrl = "";
  /** current language: in Arabic, lib-order-details refuses Latin letters in the virement comment */
  language$ = inject(LanguageService).language$;
  constructor(
    private orderService: OrderService,
    private wiSnackBarService: WiSnackBarService,
    private router: Router,
    private route: ActivatedRoute,
    public accountService: AccountService,
    private translate: TranslateService,
  ) {
    this.route.paramMap.subscribe((params) => {
      this.idOrder = Number(params.get("id"));
    });
  }

  ngOnInit(): void {
    //base url of route
    this.baseUrl = location.origin;

    this.accountService.accountSubject.subscribe((client) => {
      this.client = client;
      this.show = true;
      this.loadOrder();

      this.orderService.orderSubject.subscribe((orders: any) => {
        if (orders && orders[0] != null) {
          this.lastOrder = orders[orders.totalElements - 1];
        } else {
          this.lastOrder = null;
        }
      });
    });
  }
  onFilesClick() {
    //this.router.navigate([`account/orders/${this.idOrder}/${this.idFolder}/files`]);
  }

  printComponent() {
    let printContents = document.getElementById("order_body")?.innerHTML;
    let popupWinindow = window.open("", "_blank", "");
    popupWinindow!.onafterprint = window.close;
    popupWinindow!.document.open();
    popupWinindow!.document.write(
      "<html><head><style>" +
        "    @page {\n" +
        "      margin-top: 10px;\n" +
        "      margin-bottom: 30px;\n" +
        "\n" +
        "      @top-center {\n" +
        "        content: element(header);\n" +
        "      }\n" +
        "\n" +
        "      @bottom-center {\n" +
        "        content: element(footer);\n" +
        "      }\n" +
        "    }\n" +
        "\n" +
        "    .header {\n" +
        "      left: 0;\n" +
        "      top: 0;\n" +
        "      width: 100%;\n" +
        "      position: running(header);\n" +
        "    }\n" +
        "\n" +
        "    .footer {\n" +
        "      width: 100%;\n" +
        "      bottom: 0;\n" +
        "      left: 0;\n" +
        "      font-size: 0.8rem;\n" +
        "      color: #4f4f51;\n" +
        "      position: running(footer);\n" +
        "    }\n" +
        "\n" +
        "    .footer-pagination {\n" +
        "      position: relative;\n" +
        "    }\n" +
        "\n" +
        "    #page-number::after {\n" +
        "      counter-increment: page;\n" +
        "      counter-reset: page 1;\n" +
        "      content: counter(page);\n" +
        "    }\n" +
        "\n" +
        "    #page-count::after {\n" +
        "      content: counter(pages);\n" +
        "    }\n" +
        "\n" +
        "    body {\n" +
        "      display: block;\n" +
        "      font-family: CeraPro;\n" +
        "    }\n" +
        "\n" +
        "    .orderId {\n" +
        "      font-family: Cera Pro !important;\n" +
        "      font-weight: 700;\n" +
        "      font-size: 1.2rem;\n" +
        "      line-height: 1.125rem;\n" +
        "      color: #003147;\n" +
        "      text-align: left;\n" +
        "    }\n" +
        "\n" +
        "    .quotation-info {\n" +
        "      font-family: Cera Pro !important;\n" +
        "      display: block;\n" +
        "      width: 100%;\n" +
        "      font-weight: 500;\n" +
        "      font-size: 0.8rem;\n" +
        "      line-height: 1.25rem;\n" +
        "      color: #4b5b62;\n" +
        "    }\n" +
        "\n" +
        "    .quotation-info__left {\n" +
        "      font-size: 0.8rem;\n" +
        "      display: inline-block;\n" +
        "      width: 39%;\n" +
        "      height: auto;\n" +
        "      padding-left: 2rem;\n" +
        "    }\n" +
        "\n" +
        "    .quotation-info__right {\n" +
        "      display: inline-block;\n" +
        "      width: 50%;\n" +
        "      height: auto;\n" +
        "      padding-bottom: 2rem;\n" +
        "      float: right !important;\n" +
        "      color: #4f4f51;\n" +
        "      padding-right: 2rem;\n" +
        "    }\n" +
        "\n" +
        "    .icon2 {\n" +
        "      width: 1.5rem;\n" +
        "      height: 1.5rem;\n" +
        "    }\n" +
        "\n" +
        "    .wissal-client-info-table td {\n" +
        "      height: 2rem;\n" +
        "    }\n" +
        "\n" +
        "    .pay-info-table {\n" +
        "      font-style: normal;\n" +
        "      font-weight: 500;\n" +
        "      font-size: 0.8rem;\n" +
        "      line-height: 1rem;\n" +
        "      color: #4B5B62;\n" +
        "      border: 1px solid #F0F3F4;\n" +
        "      border-radius: 4px;\n" +
        "      border-spacing: 0;\n" +
        "    }\n" +
        "\n" +
        "    .pay-info-table td:nth-child(2) {\n" +
        "      text-align: right;\n" +
        "    }\n" +
        "\n" +
        "    .pay-info-table-head {\n" +
        "      font-weight: 700;\n" +
        "      font-size: 0.8rem;\n" +
        "      line-height: 1.125rem;\n" +
        "      text-transform: uppercase;\n" +
        "      color: #003147;\n" +
        "      text-align: left;\n" +
        "    }\n" +
        "\n" +
        "    .pay-info-table th, .pay-info-table td {\n" +
        "      height: 2.5rem;\n" +
        "      padding: 0 1rem\n" +
        "    }\n" +
        "\n" +
        "    .pay-info-table tr:nth-child(odd) {\n" +
        "      background-color: #F7F9F9;\n" +
        "    }\n" +
        "\n" +
        "    .quotation-info__right td, .quotation-info__right caption, .quotation-info__left td {\n" +
        "      font-size: 0.8rem;\n" +
        "    }\n" +
        "\n" +
        "    .quotation-info__left table, .quotation-info__right table {\n" +
        "      width: 100%;\n" +
        "    }\n" +
        "\n" +
        "    .quotation-info__right table td, .quotation-info__left table td {\n" +
        "      line-height: 1.5em;\n" +
        "      color: #4f4f51;\n" +
        "    }\n" +
        "\n" +
        "    .products-table {\n" +
        "      width: 100%;\n" +
        "      border-spacing: 0;\n" +
        "      border-collapse: collapse;\n" +
        "      font-weight: 500;\n" +
        "      font-size: 0.8rem;\n" +
        "      line-height: 13px;\n" +
        "      color: #4B5B62;\n" +
        "    }\n" +
        "\n" +
        "\n" +
        "    .products-table th, .products-table td {\n" +
        "      text-align: center;\n" +
        "      height: 2.5rem;\n" +
        "      padding-left: 1rem\n" +
        "    }\n" +
        "\n" +
        "    .products-table td:nth-child(3) {\n" +
        "      color: #003147;\n" +
        "    }\n" +
        "\n" +
        "    .products-table tr:nth-child(odd) {\n" +
        "      background-color: #f0f3f4;\n" +
        "    }\n" +
        "\n" +
        "    .products-table-head {\n" +
        "      background: #003147 !important;\n" +
        "      font-weight: 700;\n" +
        "      font-size: 1rem;\n" +
        "      line-height: 15px;\n" +
        "      color: #FFFFFF;\n" +
        "      text-align: left !important;\n" +
        "    }\n" +
        "\n" +
        "    .designation {\n" +
        "      width: 35%;\n" +
        "      white-space: normal;\n" +
        "      text-align: left !important;\n" +
        "    }\n" +
        "\n" +
        "    .resume-table {\n" +
        "      border-collapse: collapse;\n" +
        "      width: 100%;\n" +
        "      border-spacing: 0;\n" +
        "      float: right;\n" +
        "    }\n" +
        "\n" +
        "    .resume-table td {\n" +
        "      font-style: normal;\n" +
        "      font-weight: 400;\n" +
        "      font-size: 1rem;\n" +
        "      line-height: 1.25rem;\n" +
        "      text-align: right;\n" +
        "      color: #2f3240;\n" +
        "      padding: 0.3em;\n" +
        "      height: 2em;\n" +
        "      margin-right: 0.5em;\n" +
        "    }\n" +
        "\n" +
        "    .resume-table td:first-child {\n" +
        "      width: 45%;\n" +
        "    }\n" +
        "\n" +
        "    .resume-table .bold-tit {\n" +
        "      font-weight: 700;\n" +
        "      font-size: 1.1rem;\n" +
        "      color: #003147;\n" +
        "    }\n" +
        "\n" +
        "    .green-number {\n" +
        "      width: 100%;\n" +
        "    }\n" +
        "\n" +
        "    .satim-number td:first-child {\n" +
        "      padding-right: 15px;\n" +
        "    }\n" +
        "\n" +
        "    .green-number span {\n" +
        "      font-style: normal;\n" +
        "      font-weight: 500;\n" +
        "      font-size: 0.9rem;\n" +
        "      line-height: 1.5rem;\n" +
        "      color: #4b5b62;\n" +
        "      width: 40%;\n" +
        "    }\n" +
        "\n" +
        "    .important-sec {\n" +
        "      border-top: 1px solid #003147;\n" +
        "    }\n" +
        "\n" +
        "    .important {\n" +
        "      margin-top: 1rem;\n" +
        "      text-align: left;\n" +
        "    }\n" +
        "\n" +
        "    a {\n" +
        "      color: #4B5B62;\n" +
        "      text-decoration: none;\n" +
        "    }\n" +
        "\n" +
        '  </style></head><body onload="window.print()">' +
        printContents +
        "</html>",
    );
    popupWinindow!.document.close();
  }

  openDialog(order: Order) {}

  openComplainingPopUp() {}

  OpenEvaluationComment(article: OrderProduct) {
    /*this.dialog.open(CommentEvaluationComponent, {
      data: {
        product_name: article.configurationTO!.productName,
        image: article.configurationTO!.images[0],
        productId: article.configurationTO!.productId,
        orderProductId: article.id,
        refConstructor: article.configurationTO!.refConstructor,
        codFAB: article.configurationTO!.codFAB,
        codEAN: article.configurationTO!.codEAN,
        order: this.order
      }
    });*/
  }

  /**
   * @description load the order details
   */
  private loadOrder() {
    this.showLoader = true;
    this.orderService.getOrderById(this.idOrder!).subscribe(
      (response) => {
        if (response) {
          this.order = response;
          this.orderRef = response?.id ? `ws ${response.id}` : "";
          this.orderDate = response?.createdAt
            ? new Date(response.createdAt)
            : new Date();
          this.orderStatus = translateOrderState(this.translate, response.state);

          const price = response.delivery?.deliveryPrice;

          this.totalOrder.deliveryCost =
            price === 0 || price === null
              ? this.translate.instant("account.orderDetails.freeDelivery")
              : `${price} ${this.translate.instant("account.orderDetails.currency")}`;

          const deliveryType = response.delivery?.deliveryType;
          const address = response.delivery?.deliveryAddress;
          const hasDelivery = !!deliveryType && deliveryType !== "NO_DELIVERY";

          this.deliveryOption = hasDelivery
            ? this.DELIVERY_TYPES.includes(deliveryType)
              ? this.translate.instant(
                  `account.orderDetails.deliveryTypes.${deliveryType}`,
                )
              : deliveryType
            : "";
          this.deliveryAddress =
            hasDelivery && address
              ? {
                  address: address.addressLine1 ?? "",
                  commune: address.ville ?? "",
                  wilaya: address.wilaya ?? "",
                }
              : null;
          this.paymentMethod = response.paymentMethod ?? "";
          this.paymentOption = response.paymentMethod
            ? this.PAYMENT_METHODS.includes(response.paymentMethod)
              ? this.translate.instant(
                  `account.orderDetails.paymentMethods.${response.paymentMethod}`,
                )
              : response.paymentMethod
            : "";
          this.transferReceipt = this.toTransferReceipt(
            response.paymentReceipt,
            response.paymentReceiptComment,
          );

          this.totalOrder.totalAmountHT = response.total;
          this.totalOrder.amountToFinance = response.totalTTC;

          this.orderInfo = (response.orderItems || []).map((item: any) => ({
            id: item.id ?? 0,
            productName: item.configurationTO?.name ?? "",
            Quantity:
              !isNaN(item.quantity) && item.quantity != null
                ? item.quantity
                : 0,
            unitPrice:
              !isNaN(item.configurationTO?.price) &&
              item.configurationTO?.price != null
                ? item.configurationTO.price
                : 0,
            imagePath:
              item.configurationTO?.images?.[0]?.url ??
              this.DEFAULT_PRODUCT_IMAGE,
          }));

          //get the succeeded Transaction if it exists
          response.transactions.filter((tran) => {
            if (tran.errorCode == "0") {
              this.succeededTransaction = tran;
              return;
            }
          });
        }
      },
      () => {
        this.wiSnackBarService.openSnackBar(
          this.translate.instant("account.common.genericError"),
          this.translate.instant("services.snackbar.close"),
          "error-snackbar",
        );
      },
      () => {
        this.showLoader = false;
      },
    );
  }

  sendTransferReceipt(receipt: { file: File; comment: string }) {
    if (!this.order?.id || this.transferReceiptLoading) return;
    this.transferReceiptLoading = true;
    this.orderService
      .addPaymentReceipt(receipt.file, receipt.comment, this.order.id)
      .subscribe(
        () => {
          //the API doesn't return the receipt url: open the local file until the order is reloaded
          this.transferReceipt = {
            fileName: receipt.file.name,
            url: URL.createObjectURL(receipt.file),
            comment: receipt.comment || undefined,
          };
          this.transferReceiptLoading = false;
          this.loadOrder();
          this.wiSnackBarService.openSnackBar(
            this.translate.instant("account.orderDetails.receiptSent"),
            this.translate.instant("services.snackbar.ok"),
            "success-snackbar",
          );
        },
        () => {
          this.transferReceiptLoading = false;
          this.wiSnackBarService.openSnackBar(
            this.translate.instant("account.orderDetails.receiptSendError"),
            this.translate.instant("services.snackbar.close"),
            "error-snackbar",
          );
        },
      );
  }

  /**
   * @description map the receipt of the order details response (paymentReceipt is its url)
   */
  private toTransferReceipt(
    paymentReceipt?: string,
    paymentReceiptComment?: string,
  ): { fileName: string; url: string; comment?: string } | null {
    const fileName = paymentReceipt?.split("/").pop() ?? "";
    return fileName
      ? {
          fileName,
          url: paymentReceipt!,
          comment: paymentReceiptComment || undefined,
        }
      : null;
  }

  navigateToPayMethods() {
    this.router.navigate(["/cart/payment/", this.order?.id], {
      queryParams: { disableMode: true },
    });
  }

  remakePayment() {
    this.router.navigate(["/cart/payment/", this.order?.id]);
  }

  OpenActivationKeysDialog(article: OrderProduct) {
    /* this.dialog.open(ActivationKeysPopUpComponent, {
      data: {
        product_name: article.configurationTO!.productName,
        image: article.configurationTO!.images[0],
        productId: article.configurationTO!.productId,
        order: this.order,
        licenseKeySet: article.licenseKeyTOSet,
        installLink: article.configurationTO!.installLink
      }
    });*/
  }

  cancelOrder() {
    this.orderService.cancelOrder(this.order!.id!).subscribe(
      () => {
        this.wiSnackBarService.openSnackBar(
          this.translate.instant("account.orderDetails.orderCanceled"),
          this.translate.instant("services.snackbar.ok"),
          "success-snackbar",
        );
        this.order!.state = "CANCELED";
        const ods = this.orderService.orderSubject.getValue();
        ods?.content.map((o) => {
          if (o.id === this.order?.id) {
            o.state = "CANCELED";
          }
        });
        this.orderService.orderSubject.next(ods);
      },
      () =>
        this.wiSnackBarService.openSnackBar(
          this.translate.instant("account.common.genericError"),
          this.translate.instant("services.snackbar.close"),
          "error-snackbar",
        ),
    );
  }

  displayCibResponse() {
    this.order?.transactions.forEach((transaction) => {
      if (
        transaction.message !== null &&
        transaction.errorCode == "0" &&
        this.order?.paymentState === "PAYED"
      ) {
        window.open(
          `${this.baseUrl}/account/ePay/${this.idOrder}?` +
            "orderId=" +
            transaction.orderGatewayId +
            "&orderNumber=" +
            transaction.orderId +
            "&ErrorCode=" +
            transaction.errorCode + // 0 if transaction succeeded or 2 if transaction failed
            "&MessageReturn=" +
            transaction.message +
            "&code=" +
            transaction.authorizationNumber +
            "&order_id=" +
            transaction.paymentOrderId +
            "&amount=" +
            transaction.paymentAmount +
            "&date=" +
            transaction.paymentDate +
            "&fromDetails=true",
          "_blank",
        );
      } else if (
        transaction.message !== null &&
        transaction.errorCode == "2" &&
        this.order?.paymentState === "FAILED"
      ) {
        window.open(
          `${this.baseUrl}/account/ePay/${this.idOrder}?` +
            "orderId=" +
            transaction.orderGatewayId +
            "&orderNumber=" +
            transaction.orderId +
            "&ErrorCode=" +
            transaction.errorCode + // 0 if transaction succeeded or 2 if transaction failed
            "&MessageReturn=" +
            transaction.message +
            "&code=" +
            transaction.authorizationNumber +
            "&order_id=" +
            transaction.paymentOrderId +
            "&amount=" +
            transaction.paymentAmount +
            "&date=" +
            transaction.paymentDate +
            "&fromDetails=true",
          "_blank",
        );
      }
    });
  }

  makePdf() {
    this.isExporting = true;

    this.orderService
      .downloadOrderBill(this.idOrder!)
      .subscribe((blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");

        anchor.href = url;
        anchor.download = `${this.translate.instant("shared.orderBillFileName")}_${new DatePipe("fr").transform(Date.now(), "yyyy-MM-dd_HH-mm-ss")}.pdf`;

        document.body.appendChild(anchor);
        anchor.click();

        window.URL.revokeObjectURL(url);
        anchor.remove();

        this.isExporting = false;
      });
  }

  //send bill to current client
  sendOrderBillByMail() {
    this.emailIsSending = true;
    this.orderService
      .sendOrderBillToCurrentClient(this.idOrder!)
      .subscribe((res) => {
        if (res.body!.toString() == "Email sent successfully !") {
          this.emailIsSending = false;
          this.wiSnackBarService.openSnackBar(
            this.translate.instant("account.orderDetails.billEmailSent"),
            this.translate.instant("services.snackbar.close"),
            "success-snackbar",
          );
        }
      });
  }
}
